import type { DpEvent } from '@/core/events/DpEvent';

export class PingEvent implements DpEvent {
  static readonly eventName = 'User:Ping';

  name = PingEvent.eventName;
}
